import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
  createFilterOptions,
  tabIsActive,
} from '../../components/Dashboard/OfferNav';
import Badge from 'material-ui/Badge';
import { withStyles } from 'material-ui/styles';
import Notification from 'material-ui-icons/NotificationsActive';
import Menu, { MenuItem } from 'material-ui/Menu';

const styles = (theme) => ({
  badge: {
    margin: `0 ${theme.spacing.unit * 2}px`,
    '&:hover': {
      color: 'black',
    },
  },
  customBadge: {
    backgroundColor: 'red',
    color: 'white',
    top: '-6px',
    right: '-6px',
    width: 18,
    height: 18,
  },
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

class Links extends React.Component {
  state = {
    anchorEl: null,
  };
  handleClickListItem = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ anchorEl: null });
    window.open('/account/preferences', '_self');
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  render() {
    const { logout, open, location, canViewOffers, investorUser, classes } =
      this.props;

    const { tenant } = this.context;

    const filterOptions = createFilterOptions(tenant);
    const { anchorEl } = this.state;
    return (
      <nav
        className={`nav-menu-3 w-nav-menu ${open ? 'w--nav-menu-open' : ''}`}
        style={{
          transform: 'translateY(0px) translateX(0px)',
          transition: 'transform 400ms ease 0s',
        }}
      >
        <NavLink
          to='/dashboard'
          activeClassName='dash-current-page'
          className={`nav-link w-nav-link ${open ? 'w--nav-link-open' : ''}`}
          style={{ maxWidth: 728 }}
        >
          Dashboard
        </NavLink>
        {location.pathname.includes('dashboard') && canViewOffers ? (
          <div className='div-block-6 w-hidden-main'>
            {Object.keys(filterOptions).map((option) => (
              <NavLink
                key={option}
                className='nav-link w-nav-link w--nav-link-open'
                style={{ maxWidth: 728 }}
                activeClassName='dash-current-page'
                to={filterOptions[option].to}
                isActive={(match, loc) => tabIsActive(match, loc, option)}
              >
                {filterOptions[option].title}
              </NavLink>
            ))}
          </div>
        ) : null}
        <NavLink
          to='/account'
          activeClassName='dash-current-page'
          className={`nav-link w-nav-link ${open ? 'w--nav-link-open' : ''}`}
          style={{ maxWidth: 728 }}
        >
          Account
        </NavLink>
        <NavLink
          to='/dashboard/my-investments'
          activeClassName='dash-current-page'
          className={`nav-link w-nav-link ${open ? 'w--nav-link-open' : ''}`}
          style={{ maxWidth: 728 }}
        >
          My Investments
        </NavLink>

        <div
          onClick={logout}
          onKeyDown={(e) => e.keyCode === 13 && logout(e)}
          role='menuitem'
          tabIndex={0}
          className={`nav-link w-nav-link ${open ? 'w--nav-link-open' : ''}`}
          style={{ maxWidth: 728, outline: 'none' }}
        >
          Log out
        </div>
        {investorUser.notifyInvestmentPreference && (
          <div
            className='nav-link w-nav-link w--nav-link-open'
            style={{
              maxWidth: 728,
              outline: 'none',
              color: 'rgba(0, 0, 0, 0.6)',
            }}
          >
            <Badge
              className={classes.badge}
              onClick={this.handleClickListItem}
              badgeContent={1}
              classes={{ badge: classes.customBadge }}
              color='primary'
            >
              <Notification />
            </Badge>
            <Menu
              id='render-props-menu'
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <MenuItem onClick={this.handleMenuItemClick}>
                {' '}
                You have incomplete investment preference
              </MenuItem>
            </Menu>
          </div>
        )}
      </nav>
    );
  }
}

const mapStateToProps = ({ router, investorUser }) => ({
  location: router.location,
  canViewOffers: investorUser.canViewOffers,
  investorUser,
});

Links.propTypes = {
  logout: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  canViewOffers: PropTypes.bool.isRequired,
};

Links.contextTypes = {
  tenant: PropTypes.object,
};

export default connect(mapStateToProps)(withStyles(styles)(Links));



// WEBPACK FOOTER //
// ./src/Layouts/Nav/Links.js